<template>
  <login-card-shell
    title="ระบบบุคลากรการศึกษา"
    subtitle="ครูอัตราจ้าง ลูกจ้างประจำ ลูกจ้างชั่วคราว"
    username-hint="Username: รหัสบัตรประชาชน"
    password-hint="ลืมรหัสผ่าน? กดปุ่มด้านล่าง"
    notice-text="ครั้งแรกเข้าใช้งาน/ลืมรหัสผ่าน ติดต่อผู้ดูแลระบบ หรือกด 'ลืมรหัสผ่าน'"
    logo-icon-src="https://cdn.lordicon.com/knzzcfyy.json"
    theme-color-start="#a86400"
    theme-color-end="#a86400"
    :dialog-value="dialogLogin"
    @update:dialogValue="dialogLogin = $event"
    :snackbar-value="dialog"
    @update:snackbarValue="dialog = $event"
    :snackbar-msg="dialog_msg"
    :loading="loading"
    :lockout-message="lockoutMessage"
    @submit="userEtcLogin"
  >
    <template v-slot:extra-action>
      <div class="d-flex justify-center flex-wrap">
        <reset-password-dialog person-type="personnel_etc" />
        <usage-guide-dialog person-type="personnel_etc" />
      </div>
    </template>

    <login-failed-options-dialog v-model="showFailedOptions" person-type="personnel_etc" />

    <v-form ref="form" lazy-validation>
      <v-text-field
        color="warning"
        prepend-icon="mdi-account"
        name="login"
        label="ชื่อผู้ใช้งาน : รหัสบัตรประชาชน"
        type="text"
        v-model="personnel_etc_id_card"
        :rules="[v => !!v || 'กรุณากรอกชื่อผู้ใช้งาน']"
        rounded
        outlined
        class="enhanced-input mb-4"
      ></v-text-field>

      <v-text-field
        color="warning"
        name="password"
        label="รหัสผ่าน"
        prepend-icon="mdi-lock-outline"
        id="password"
        v-model="personnel_etc_pass"
        rounded
        :rules="[v => !!v || 'กรุณากรอกรหัสผ่าน']"
        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
        :type="show1 ? 'text' : 'password'"
        @click:append="show1 = !show1"
        outlined
        class="enhanced-input"
        hint="จำรหัสผ่านไม่ได้? กด 'ลืมรหัสผ่าน' ด้านล่าง"
        persistent-hint
      ></v-text-field>
    </v-form>
  </login-card-shell>
</template>

<script>
import LoginCardShell from "./LoginCardShell.vue";
import resetPasswordDialog from "./ResetPasswordDialog.vue";
import usageGuideDialog from "./UsageGuideDialog.vue";
import loginFailedOptionsDialog from "./LoginFailedOptionsDialog.vue";

const VALID_M_TYPES = [
  "governmentteach", "governmentsp", "government", "temporary", "temporary_job", "permanent"
];

export default {
  components: { LoginCardShell, resetPasswordDialog, usageGuideDialog, loginFailedOptionsDialog },
  data() {
    return {
      ApiKey: "HRvec2021",
      show1: false,
      dialogLogin: false,
      personnel_etc_id_card: "",
      personnel_etc_pass: "",
      dialog: false,
      dialog_msg: "",
      loading: false,
      lockoutMessage: "",
      showFailedOptions: false
    };
  },
  methods: {
    async userEtcLogin() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;
      this.lockoutMessage = "";
      try {
        let result = await this.$http.post("login_etc.php?crud=user", {
          personnel_etc_id_card: this.personnel_etc_id_card,
          personnel_etc_pass: this.personnel_etc_pass
        });

        if (result.data.user_status === "Locked") {
          const minutes = Math.ceil((result.data.retry_after || 0) / 60);
          this.lockoutMessage = `ล็อกอินผิดเกินกำหนด กรุณารออีกประมาณ ${minutes} นาที`;
          return;
        }

        if (result.data.user_status === "NeedThaidVerify") {
          // รหัสผ่านถูกต้องแล้ว แต่ยังไม่ออก session จนกว่าจะยืนยันตัวตนผ่าน ThaiID สำเร็จ —
          // ต้อง redirect ทั้งหน้า (ไม่ใช่ XHR) เพราะเป็น cross-origin ไปหน้า DOPA
          this.dialog_msg = "กำลังนำท่านไปยืนยันตัวตนทางดิจิทัลผ่าน ThaiID (ออกให้โดยกรมการปกครอง กระทรวงมหาดไทย) กรุณาสแกน QR Code หรือยืนยันผ่านแอป ThaID ในขั้นตอนถัดไป...";
          this.dialog = true;
          window.location.href = result.data.authorize_url;
          return;
        }

        if (result.data.personnel_etc_m_type) {
          let user = result.data;
          user.system_lock = false;

          if (VALID_M_TYPES.includes(user.personnel_etc_m_type)) {
            localStorage.setItem("user", JSON.stringify(user));
            localStorage.setItem(
              "force_password_change",
              user.must_change_password ? "1" : "0"
            );
            this.dialogLogin = false;
            this.dialog = true;
            this.dialog_msg = "เข้าสู่ระบบสำเร็จ - บุคลากรการศึกษา";
            setTimeout(() => {
              this.$router.push("/userEtc");
            }, 1500);
          } else {
            localStorage.clear();
            this.dialog = true;
            this.dialog_msg = "ชื่อผู้ใช้ หรือรหัสผ่าน ไม่ถูกต้อง";
            this.showFailedOptions = true;
          }
        } else {
          localStorage.clear();
          this.dialog = true;
          this.dialog_msg = "ชื่อผู้ใช้ หรือรหัสผ่าน ไม่ถูกต้อง";
          this.showFailedOptions = true;
        }
      } catch (error) {
        this.dialog = true;
        this.dialog_msg = "เกิดข้อผิดพลาดในการเข้าสู่ระบบ";
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.enhanced-input .v-input__control {
  transition: all 0.3s ease;
}

.enhanced-input:hover .v-input__control {
  transform: translateY(-1px);
}
</style>
